/* Match data — HLTV-style mock dataset for CS2 OPEN · СКО */

export const M_TEAMS = {
  NVJ: { name: 'NaVi Jr.',      tag: 'NVJ', seed: 1, country: 'kz', color: '#E6B73C' },
  STW: { name: 'Steppe Wolves', tag: 'STW', seed: 2, country: 'kz', color: '#E1131A' },
  AML: { name: 'Aim Lords',     tag: 'AML', seed: 3, country: 'kz', color: '#8847FF' },
  ECO: { name: 'Eco Frags',     tag: 'ECO', seed: 4, country: 'kz', color: '#56C08A' },
  PTF: { name: 'Petro Force',   tag: 'PTF', seed: 5, country: 'kz', color: '#4B69FF' },
  NST: { name: 'North Stars',   tag: 'NST', seed: 6, country: 'ru', color: '#3AC6E0' },
  CLM: { name: 'Clutch Minds',  tag: 'CLM', seed: 7, country: 'kz', color: '#F2B84B' },
  SKF: { name: 'SKU Falcons',   tag: 'SKF', seed: 8, country: 'kz', color: '#E0588E' },
};

export const M_ROSTERS = {
  NVJ: [
    { nick: 'n0rb',    real: 'Никита Орлов',     c: 'kz', rt: 31200 },
    { nick: 'zevver',  real: 'Алмас Жунусов',    c: 'kz', rt: 27400 },
    { nick: 'sk1y',    real: 'Дамир Сагатов',    c: 'kz', rt: 25900 },
    { nick: 'm0ney',   real: 'Артур Лим',        c: 'ru', rt: 24100 },
    { nick: 'electr0', real: 'Тимур Касен',      c: 'kz', rt: 23300 },
  ],
  STW: [
    { nick: 's1lent',  real: 'Алихан Сейтжанов', c: 'kz', rt: 21450 },
    { nick: 'qpex',    real: 'Данияр Ким',       c: 'kz', rt: 20800 },
    { nick: 'dao',     real: 'Олжас Туреев',     c: 'kz', rt: 19900 },
    { nick: 'batr',    real: 'Батыр Нуров',      c: 'kz', rt: 18600 },
    { nick: 'nurik',   real: 'Нурлан Аман',      c: 'kz', rt: 17500 },
  ],
  AML: [
    { nick: 'vladcho', real: 'Владислав Цой',    c: 'kz', rt: 22100 },
    { nick: 'ruslo',   real: 'Руслан Ахметов',   c: 'kz', rt: 19500 },
    { nick: 'shadX',   real: 'Санжар Ким',       c: 'kz', rt: 18800 },
    { nick: 'kira',    real: 'Кирилл Ос',        c: 'ru', rt: 17200 },
    { nick: 'tenz1',   real: 'Темир Сейт',       c: 'kz', rt: 16400 },
  ],
  ECO: [
    { nick: 'marj',    real: 'Марат Жакыпов',    c: 'kz', rt: 16900 },
    { nick: 'b00m',    real: 'Бекзат Омаров',    c: 'kz', rt: 15200 },
    { nick: 'leshy',   real: 'Алексей Шин',      c: 'ru', rt: 14800 },
    { nick: 'dust',    real: 'Дастан Усен',      c: 'kz', rt: 13900 },
    { nick: 'crux',    real: 'Кирилл Ус',        c: 'kz', rt: 12700 },
  ],
};

function buildRounds(scoreA, scoreB) {
  const types = ['kills', 'kills', 'kills', 'bomb', 'defuse', 'time', 'kills', 'bomb'];
  const total = scoreA + scoreB;
  let a = 0, b = 0;
  const pattern = [];
  for (let r = 0; r < total; r++) {
    const remA = scoreA - a, remB = scoreB - b, left = total - r;
    let pickA;
    if (remA <= 0) pickA = false;
    else if (remB <= 0) pickA = true;
    else pickA = ((r * 7 + 3) % 5) < (remA / left) * 5;
    if (pickA) a++; else b++;
    pattern.push(pickA ? 'A' : 'B');
  }
  return Array.from({ length: total }, (_, r) => {
    const firstHalf = r < 12, w = pattern[r];
    const side = firstHalf ? (w === 'A' ? 'ct' : 't') : (w === 'A' ? 't' : 'ct');
    return { w, side, type: types[(r * 3 + 1) % types.length] };
  });
}

function buildBoard(roster, won, scoreWeWon, scoreTheyWon) {
  const base = won ? [23, 20, 18, 16, 14] : [21, 18, 16, 14, 12];
  const deaths = won ? [12, 14, 15, 16, 17] : [15, 16, 17, 18, 19];
  return roster.map((p, i) => {
    const k = base[i] + ((i * 5 + scoreWeWon) % 4) - 1;
    const d = deaths[i] + ((i * 3 + scoreTheyWon) % 3) - 1;
    const a = [7, 6, 8, 5, 9][i];
    const adr = Math.round((k * 3.0 + a * 0.7 + 24) * 10) / 10;
    const kast = Math.min(95, 60 + k - Math.round(d / 3) + (won ? 8 : 0));
    const hs = 40 + ((i * 11 + k) % 38);
    const rating = Math.max(0.58, Math.min(1.9, Math.round((0.72 + (k - d) * 0.032 + (adr - 70) * 0.006 + (kast - 72) * 0.004 + (won ? 0.06 : 0)) * 100) / 100));
    return { ...p, k, d, a, plus: k - d, adr, kast, hs, rating };
  }).sort((x, y) => y.rating - x.rating);
}

export const LIVE_MATCH = {
  id: 'm-live-1', status: 'live', stars: 3,
  event: 'CS2 OPEN · СКО', stage: '1/2 финала', bo: 3,
  A: 'NVJ', B: 'STW',
  mapsWon: { A: 1, B: 0 },
  spectators: 1840,
  veto: [
    { team: 'STW', act: 'remove', map: 'Anubis' },
    { team: 'NVJ', act: 'remove', map: 'Vertigo' },
    { team: 'STW', act: 'pick', map: 'Mirage' },
    { team: 'NVJ', act: 'pick', map: 'Inferno' },
    { team: 'STW', act: 'remove', map: 'Nuke' },
    { team: 'NVJ', act: 'remove', map: 'Dust2' },
    { team: '—', act: 'decider', map: 'Ancient' },
  ],
  maps: [
    { name: 'Mirage', a: 13, b: 9, status: 'finished', halfA: 8, halfB: 4 },
    { name: 'Inferno', a: 12, b: 10, status: 'live', live: { round: 23, ctTeam: 'A', clock: 95, bomb: true } },
    { name: 'Ancient', a: 0, b: 0, status: 'upcoming' },
  ],
};
LIVE_MATCH.maps[0].board = { A: buildBoard(M_ROSTERS.NVJ, true, 13, 9), B: buildBoard(M_ROSTERS.STW, false, 9, 13) };
LIVE_MATCH.maps[0].rounds = buildRounds(13, 9);
LIVE_MATCH.maps[1].board = { A: buildBoard(M_ROSTERS.NVJ, true, 12, 10), B: buildBoard(M_ROSTERS.STW, false, 10, 12) };
LIVE_MATCH.maps[1].rounds = buildRounds(12, 10);

export const UPCOMING_MATCHES = [
  { id: 'm-up-1', status: 'upcoming', stars: 2, event: 'CS2 OPEN · СКО', stage: '1/2 финала', bo: 3,
    A: 'AML', B: 'ECO', time: 'Сегодня · 19:00', mapsWon: { A: 0, B: 0 } },
  { id: 'm-up-2', status: 'upcoming', stars: 3, event: 'CS2 OPEN · СКО', stage: 'ФИНАЛ', bo: 5,
    A: 'NVJ', B: 'AML', time: 'Завтра · 18:00', mapsWon: { A: 0, B: 0 }, tbd: true },
  { id: 'm-up-3', status: 'upcoming', stars: 1, event: 'СКУ LAN #3', stage: 'Групповой этап', bo: 1,
    A: 'PTF', B: 'NST', time: 'Сегодня · 21:30', mapsWon: { A: 0, B: 0 } },
];

function makeFinished(id, A, B, stage, bo, stars, mapDefs, ago) {
  const maps = mapDefs.map(md => {
    const aWon = md.a > md.b;
    return {
      name: md.name, a: md.a, b: md.b, status: 'finished',
      halfA: md.halfA, halfB: md.halfB,
      rounds: buildRounds(md.a, md.b),
      board: {
        A: buildBoard(M_ROSTERS[A] || M_ROSTERS.AML, aWon, md.a, md.b),
        B: buildBoard(M_ROSTERS[B] || M_ROSTERS.ECO, !aWon, md.b, md.a),
      },
    };
  });
  const mapsWon = maps.reduce((acc, m) => { if (m.a > m.b) acc.A++; else acc.B++; return acc; }, { A: 0, B: 0 });
  return { id, status: 'finished', stars, event: 'CS2 OPEN · СКО', stage, bo, A, B, maps, mapsWon, ago };
}

export const RESULT_MATCHES = [
  makeFinished('m-r-1', 'NVJ', 'SKF', '1/4 финала', 3, 2,
    [{ name: 'Mirage', a: 13, b: 7, halfA: 9, halfB: 3 }, { name: 'Nuke', a: 13, b: 11, halfA: 7, halfB: 5 }], '2 ч назад'),
  makeFinished('m-r-2', 'STW', 'NST', '1/4 финала', 3, 2,
    [{ name: 'Ancient', a: 13, b: 10, halfA: 8, halfB: 4 }, { name: 'Dust2', a: 11, b: 13, halfA: 5, halfB: 7 }, { name: 'Inferno', a: 13, b: 9, halfA: 7, halfB: 5 }], '5 ч назад'),
  makeFinished('m-r-3', 'AML', 'PTF', '1/4 финала', 3, 1,
    [{ name: 'Inferno', a: 13, b: 6, halfA: 9, halfB: 3 }, { name: 'Mirage', a: 13, b: 8, halfA: 6, halfB: 6 }], 'вчера'),
  makeFinished('m-r-4', 'ECO', 'CLM', '1/4 финала', 3, 1,
    [{ name: 'Anubis', a: 10, b: 13, halfA: 6, halfB: 6 }, { name: 'Mirage', a: 13, b: 11, halfA: 5, halfB: 7 }, { name: 'Ancient', a: 16, b: 14, halfA: 7, halfB: 5 }], 'вчера'),
];

export const M_LEADERS = [
  { nick: 'n0rb',   team: 'NVJ', c: 'kz', rating: 1.34, kd: '1.41', maps: 6 },
  { nick: 's1lent', team: 'STW', c: 'kz', rating: 1.27, kd: '1.30', maps: 5 },
  { nick: 'zevver', team: 'NVJ', c: 'kz', rating: 1.21, kd: '1.24', maps: 6 },
  { nick: 'vladcho',team: 'AML', c: 'kz', rating: 1.16, kd: '1.18', maps: 4 },
  { nick: 'qpex',   team: 'STW', c: 'kz', rating: 1.12, kd: '1.09', maps: 5 },
  { nick: 'marj',   team: 'ECO', c: 'kz', rating: 1.08, kd: '1.11', maps: 5 },
];
